<div
  class="item-list_container"
  data-cy="item-list">
  @if (items && !items.length) {
    <div
      data-cy="item-list-empty-row"
      class="item-list_row item-list_row--empty">
      {{ 'noResultsFound' | translate }}
    </div>
  }

  @for (item of items; track trackByItem($index, item)) {
    <div
      class="item-list_row"
      data-cy="item-list-row"
      [attr.data-cy-row-id]="item?.id"
      [ngClass]="{
        'pointer': clickable,
        'item-list_row--green': greenMarker?.visible(item),
        'item-list_row--orange': orangeMarker?.visible(item),
        'item-list_row--red': redMarker?.visible(item)
      }"
      appHoverItem
      appSwipeItem
      (click)="clickable && onItemClick.emit(item)">
      <div class="item-list_icon">
        @for (icon of icons; track icon.name) {
          @if (icon?.visible(item)) {
            <div
              matTooltip="{{ icon?.getTooltip && icon.getTooltip(item) }}"
              matTooltipPosition="above">
              <i class="fas fa-{{icon.name}}"></i>
            </div>
          }
        }
      </div>
      @for (column of columns; track column.fieldName) {
        <div
          class="item-list_cell {{column.fontClass}} col-xs-1 {{column.isSmall ? 'col-md-1' : 'col-md-2'}}"
          data-cy="item-list-cell"
          [attr.data-cy-column]="column.fieldName"
          [ngClass]="{'item-list_cell--hover-only': column.hoverOnly, 'hidden-mobile': column.isHiddenOnMobile}" >
          @if (showWarning && !item[column.fieldName]) {
            <span
              matTooltip="{{ (column.translationKey | translate | titlecase) + ' ' + ('isMissing' | translate) + '!' }}"
              matTooltipPosition="above">
              <i class="fa-exclamation-circle fas red"></i>
            </span>
          }
          <span
            matTooltip="{{ column.translationKey | translate | titlecase }}"
            [matTooltipPosition]="column.repositionTooltip ? 'left' : 'above'"
            [innerHTML]="item[column.fieldName]">
          </span>
        </div>
      }
      <div
        data-cy="item-list-actions"
        class="item-list_button-container end-xs col-xs-offset-{{ 4 - columns?.length }} col-md-offset-{{ (4 - columns?.length) * 2}}"
      [ngClass]="{
          'col-xs-8 col-md-4': !reducedActionsMode, 
          'col-md-3 col-xs-7 col-md-offset-0 col-xs-offset-0': reducedActionsMode 
        }">
        @for (action of actions; track action.translationKey) {
          @if (action.visible(item)) {
            <button
              click-stop-propagation
              class="item-list_button"
              [attr.data-cy]="action.dataCy ? action.dataCy(item) : 'item-list-action'"
              [attr.data-cy-action]="action.translationKey"
              [ngClass]="{'item-list_button--disabled': action.isLoading}"
              type="button"
              (click)="!action.isLoading && action.execute(item, action)">
              <span
                [ngClass]="{'vis-hidden': action.isLoading}">
                {{ action.translationKey | translate }}
              </span>
              @if (action.isLoading) {
                <app-load
                  class="item-list_loader"
                  [isLight]="true">
                </app-load>
              }
            </button>
          }
        }
      </div>
    </div>
  }

  @if (pageable && showPaginator) {
    <mat-paginator
      #paginator
      [length]="count"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 20, 50, 100]"
      (page)="changePage($event)">
    </mat-paginator>
  }
</div>
